import React, { useEffect } from 'react';
import { Meteor } from 'meteor/meteor';
import { strings } from '/imports/strings';
import { LoadingFullScreen } from '/imports/ui/LoadingFullScreen';

export const Logout = () => {
  useEffect(() => { Meteor.logout(); }, []);
  return (
    <div className="logout">
      <LoadingFullScreen caption={strings.Logout()} />
    </div>
  );
};
